"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReamortizationExecutionStatus = exports.ReamortizationError = exports.ReamortizationIneligibleReason = void 0;
var ReamortizationIneligibleReason;
(function (ReamortizationIneligibleReason) {
    ReamortizationIneligibleReason["DELINQUENCY"] = "DELINQUENCY";
    ReamortizationIneligibleReason["NO_FIXED_PLANS"] = "NO_FIXED_PLANS";
    ReamortizationIneligibleReason["INSUFFICIENT_PREPAYMENT"] = "INSUFFICIENT_PREPAYMENT";
    ReamortizationIneligibleReason["EOD_HOLD"] = "EOD_HOLD";
})(ReamortizationIneligibleReason || (exports.ReamortizationIneligibleReason = ReamortizationIneligibleReason = {}));
var ReamortizationError;
(function (ReamortizationError) {
    ReamortizationError["OFFER_CHANGED"] = "Your offer has changed. Please see updated terms.";
    ReamortizationError["EXECUTION_FAILED"] = "Failed to execute reamortization.";
    ReamortizationError["REAMORTIZATION_IN_PROGRESS"] = "A reamortization request is already in progress or was recently processed. Please try again later.";
})(ReamortizationError || (exports.ReamortizationError = ReamortizationError = {}));
var ReamortizationExecutionStatus;
(function (ReamortizationExecutionStatus) {
    ReamortizationExecutionStatus["PROCESSING"] = "PROCESSING";
    ReamortizationExecutionStatus["COMPLETED"] = "COMPLETED";
    ReamortizationExecutionStatus["FAILED"] = "FAILED";
})(ReamortizationExecutionStatus || (exports.ReamortizationExecutionStatus = ReamortizationExecutionStatus = {}));
